export function formatBandwidth(kbps: number) {
  if ((kbps / 1_024) % 5 === 0) {
    return kbps / 1_024;
  }
  return kbps / 1_000;
}
